var _defs, _path, _path2, _path3, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsitesMobFriendlyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "websites-mob-friendly-icon_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70.87 70.87"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".websites-mob-friendly-icon_svg__cls-2{stroke:#010101;stroke-miterlimit:10;stroke-width:2px;fill:#fff}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.09 27.12c1.16 11.7-8.59 21.45-20.29 20.29-8.66-.86-15.66-7.86-16.52-16.52-1.16-11.7 8.59-21.45 20.29-20.29 8.66.86 15.66 7.86 16.52 16.52z",
    fill: "#f9d8cd",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "websites-mob-friendly-icon_svg__cls-2",
    d: "M10.14 23.83h37.83c.82 0 1.46.67 1.46 1.46v27.72c0 .82-.67 1.46-1.46 1.46H10.14c-.82 0-1.46-.67-1.46-1.46V25.29c0-.79.67-1.46 1.46-1.46zM16 59.36h26.14M31.52 54.47h-4.89l-4.86 4.89h14.6l-4.85-4.89z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.68 50.74h40.78v2.28c0 .82-.67 1.46-1.46 1.46H10.14c-.82 0-1.46-.67-1.46-1.46v-2.28z",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    fill: "#e84b0f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "websites-mob-friendly-icon_svg__cls-2",
    d: "M40.32 33.91H58.6c.58 0 1.03.46 1.03 1.03v23.35c0 .58-.46 1.03-1.03 1.03H40.32c-.58 0-1.03-.46-1.03-1.03V34.94c-.03-.58.46-1.03 1.03-1.03zM47.09 36.4h4.74"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "websites-mob-friendly-icon_svg__cls-2",
    cx: 49.46,
    cy: 56.08,
    r: 0.27
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "websites-mob-friendly-icon_svg__cls-2",
    d: "M55.35 45.79h7.29c.3 0 .55.24.55.55v12.45c0 .3-.24.55-.55.55h-7.29c-.3 0-.55-.24-.55-.55V46.34c0-.3.24-.55.55-.55z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "websites-mob-friendly-icon_svg__cls-2",
    cx: 58.99,
    cy: 56.9,
    r: 0.27
  }))));
}
export default SvgWebsitesMobFriendlyIcon;